function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29",
  height: "29",
  viewBox: "0 0 29 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.503 20.17a5.799 5.799 0 100-11.598 5.799 5.799 0 000 11.598z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.344 0h-1.686v7.602h1.686V0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.343 21.398h-1.686V29h1.686v-7.602z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29 13.656h-7.603v1.686h7.602v-1.686z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.602 13.656H0v1.686h7.602v-1.686z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.57 19.378l-1.192 1.192 4.183 4.183 1.193-1.192-4.184-4.183z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.44 4.247L4.248 5.439 8.43 9.622 9.623 8.43 5.44 4.247z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.56 4.241l-4.182 4.184 1.192 1.192 4.183-4.184-1.192-1.192z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.43 19.374l-4.182 4.184 1.193 1.192 4.182-4.184-1.192-1.192z",
  fill: "#fff"
})));